import { FINISH_LOADING, START_LOADING } from '.'

const startLoadingAction = () => ({ type: START_LOADING })
const finishLoadingAction = () => ({ type: FINISH_LOADING })

export { startLoadingAction, finishLoadingAction }
